import { getSceneState } from "../../stores/sceneStore";
import { normalizeCollisionGeomKind } from "../../utils/collisionGeomKinds";
import { getHFieldWithAppliedHeightScale } from "../../utils/terrainFloor";
import { createCollisionGeometry, createVisualGeometry } from "../collisionVisualization";

export function attachPrimitiveGeoms({
  bodyNode,
  visualGroup,
  materials,
  showCollision,
  showVisual,
}) {
  // Add primitive collision geometries (those without mesh attribute)
  if (bodyNode.geoms && bodyNode.geoms.length > 0) {
    bodyNode.geoms.forEach((geom) => {
      const isPendingMeshVisual =
        geom?.visualOnly === true &&
        !geom.mesh &&
        String(geom.kind || geom.type || "").toLowerCase() === "mesh";

      // Process primitive visual geometries (those with visualOnly=true but no mesh)
      if (geom.visualOnly === true && !geom.mesh && !isPendingMeshVisual) {
        const rawHField =
          geom.kind === "hfield" && geom.heightField
            ? getSceneState().hfields?.[geom.heightField]
            : null;
        const hfieldDef = rawHField ? getHFieldWithAppliedHeightScale(rawHField) : null;
        const renderSize = hfieldDef?.size || geom.size || [0.1, 0.1, 0.1];

        // Create visual geometry
        const visualObj = createVisualGeometry(
          geom.position || [0, 0, 0],
          geom.orientation || [1, 0, 0, 0],
          renderSize,
          geom.kind || "sphere",
          geom.materials?.[0],
          showVisual,
          materials,
          hfieldDef
        );

        if (visualObj) {
          visualObj.userData = {
            ...visualObj.userData,
            type: "visual",
            bodyName: bodyNode.name,
            bodyUuid: bodyNode.uuid,
            geomName: geom.name || "visual",
            geomUuid: geom?.uuid || globalThis.crypto?.randomUUID?.() || `geom-${Date.now()}`,
            selectable: true,
          };
          visualGroup.add(visualObj);
        }
      }

      // Only process primitive collision geometries (no mesh) that are colliding (visualOnly != true)
      const isPrimitiveCollision = !geom.mesh && geom.visualOnly !== true;
      if (isPrimitiveCollision) {
        const rawHField =
          geom.kind === "hfield" && geom.heightField
            ? getSceneState().hfields?.[geom.heightField]
            : null;
        const hfieldDef = rawHField ? getHFieldWithAppliedHeightScale(rawHField) : null;
        const renderSize = hfieldDef?.size || geom.size || [0.1, 0.1, 0.1];

        // Create collision geometry
        const collisionObj = createCollisionGeometry(
          geom.position || [0, 0, 0],
          geom.orientation || [1, 0, 0, 0],
          renderSize,
          geom.kind || "sphere",
          showCollision,
          hfieldDef
        );

        if (collisionObj) {
          collisionObj.userData = {
            ...collisionObj.userData,
            type: "collision",
            collisionGeomKind: normalizeCollisionGeomKind(geom.kind),
            bodyName: bodyNode.name,
            bodyUuid: bodyNode.uuid,
            geomName: geom.name || "collision",
            geomUuid: geom?.uuid || globalThis.crypto?.randomUUID?.() || `geom-${Date.now()}`,
            selectable: true,
          };
          visualGroup.add(collisionObj);
        }
      }
    });
  }
}
